jQuery(document).ready(function($) {
    // Check if we need to highlight an updated address
    var updatedAddressId = localStorage.getItem('vitalshop_updated_address');
    if (updatedAddressId) {
        // Remove the storage item
        localStorage.removeItem('vitalshop_updated_address');
        
        // Find and highlight the updated address card
        setTimeout(function() {
            var $updatedCard = $('.address-card[data-address-id="' + updatedAddressId + '"]');
            if ($updatedCard.length) {
                $updatedCard.addClass('success-flash');
                
                // Remove animation class after animation completes
                setTimeout(function() {
                    $updatedCard.removeClass('success-flash');
                }, 600);
            }
        }, 200);
    }
    // Open modal for new address
    $(".add-new-address").on("click", function() {
        // DEBUG: Opening modal for NEW address
        $("#address-form-modal").show();
        $("#address-form-modal .modal-title").text("Neue Adresse hinzufügen");
        $("#address-form")[0].reset(); // Clear form
        $("#address_id").val(""); // Clear ID
        $("#address_is_default").prop("checked", false); // Ensure default checkbox is unchecked
        
        // Initialize custom dropdown for modal (Autocomplete disabled)
        setTimeout(function() {
            // setupModalAutocomplete(); // DISABLED: Adress-Autocomplete deaktiviert
            setupCustomDropdown();
        }, 200);
    });
    
    // Open modal for editing existing address
    $(document).on("click", ".edit-address", function() {
        var addressId = $(this).closest(".address-card").data("address-id");
        // DEBUG: Opening modal for EDIT address
        
        $("#address-form-modal").show();
        $("#address-form-modal .modal-title").text("Adresse bearbeiten");
        $("#address_id").val(addressId); // Set ID for editing
        
        // Load address data
        loadAddressForEditing(addressId);
        
        // Initialize custom dropdown for modal (Autocomplete disabled)
        setTimeout(function() {
            // setupModalAutocomplete(); // DISABLED: Adress-Autocomplete deaktiviert
            setupCustomDropdown();
        }, 200);
    });
    
    // Setup custom country dropdown
    function setupCustomDropdown() {
        $(".custom-select").off("click.custom").on("click.custom", function(e) {
            e.stopPropagation();
            
            // Close other dropdowns
            $(".custom-select").not(this).removeClass("active");
            $(".custom-options").not($(this).siblings(".custom-options")).removeClass("show");
            
            // Toggle this dropdown
            $(this).toggleClass("active");
            $(this).siblings(".custom-options").toggleClass("show");
        });
        
        $(".custom-option").off("click.custom").on("click.custom", function(e) {
            e.stopPropagation();
            
            var value = $(this).data("value");
            var text = $(this).text();
            var $wrapper = $(this).closest(".custom-select-wrapper");
            
            // Update hidden input
            $wrapper.find("input[type=hidden]").val(value);
            
            // Update display
            $wrapper.find(".selected-option").text(text);
            
            // Update selected state
            $(this).addClass("selected").siblings().removeClass("selected");
            
            // Close dropdown
            $wrapper.find(".custom-select").removeClass("active");
            $wrapper.find(".custom-options").removeClass("show");
            
            // Clear search
            $wrapper.find(".country-search").val("");
            showAllCountryOptions($wrapper);
            
        });
        
        // Country search functionality
        $(".country-search").off("input.search").on("input.search", function() {
            var searchTerm = $(this).val().toLowerCase();
            var $wrapper = $(this).closest(".custom-select-wrapper");
            
            if (searchTerm === "") {
                showAllCountryOptions($wrapper);
            } else {
                filterCountryOptions($wrapper, searchTerm);
            }
        });
        
        // Prevent dropdown close when clicking search field
        $(".country-search").off("click.search").on("click.search", function(e) {
            e.stopPropagation();
        });
        
        // Close dropdown when clicking outside
        $(document).off("click.custom-dropdown").on("click.custom-dropdown", function() {
            $(".custom-select").removeClass("active");
            $(".custom-options").removeClass("show");
        });
    }
    
    // Show all country options
    function showAllCountryOptions($wrapper) {
        $wrapper.find(".custom-option").show();
    }
    
    // Filter country options based on search term
    function filterCountryOptions($wrapper, searchTerm) {
        $wrapper.find(".custom-option").each(function() {
            var countryName = $(this).data("name") || $(this).text().toLowerCase();
            if (countryName.includes(searchTerm)) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    }
    
    // Toast notification functions
    function showToast(message, type = 'success') {
        // Remove existing toasts
        $('.toast-notification').remove();
        
        var icon = type === 'success' ? '✓' : '✕';
        var toastClass = type === 'success' ? '' : 'error';
        
        var toast = $('<div class="toast-notification ' + toastClass + '">' +
            '<div class="toast-icon">' + icon + '</div>' +
            '<span>' + message + '</span>' +
            '<button class="toast-close">×</button>' +
        '</div>');
        
        $('body').append(toast);
        
        // Show toast with animation
        setTimeout(function() {
            toast.addClass('show');
        }, 100);
        
        // Auto-hide after 4 seconds
        setTimeout(function() {
            hideToast(toast);
        }, 4000);
        
        // Manual close
        toast.find('.toast-close').on('click', function() {
            hideToast(toast);
        });
    }
    
    function hideToast(toast) {
        toast.removeClass('show');
        setTimeout(function() {
            toast.remove();
        }, 400);
    }
    
    // Setup autocomplete for modal address field
    function setupModalAutocomplete() {
        var $field = $("#address_1");
        if ($field.length === 0) return;
        
        var $container = $field.parent();
        var autocompleteId = "modal_address_autocomplete";
        
        // Remove existing dropdown
        $("#" + autocompleteId).remove();
        
        // Create autocomplete dropdown
        var $dropdown = $("<div>")
            .attr("id", autocompleteId)
            .addClass("address-autocomplete-dropdown modal-autocomplete")
            .hide();
        
        $container.append($dropdown);
        
        var searchTimeout;
        var currentRequest;
        
        $field.off("input.autocomplete").on("input.autocomplete", function() {
            var query = $(this).val().trim();
            
            clearTimeout(searchTimeout);
            if (currentRequest) currentRequest.abort();
            
            if (query.length < 3) {
                $dropdown.hide().empty();
                return;
            }
            
            searchTimeout = setTimeout(function() {
                searchModalAddresses(query, $dropdown);
            }, 300);
        });
        
        // Hide dropdown when clicking outside
        $(document).off("click.modal-autocomplete").on("click.modal-autocomplete", function(e) {
            if (!$(e.target).closest($container).length) {
                $dropdown.hide();
            }
        });
    }
    
    // Search addresses for modal (using Photon API)
    function searchModalAddresses(query, $dropdown) {
        
        $dropdown.html('<div class="autocomplete-loading">🔍 Suche Adressen...</div>').show();
        
        var apiUrl = "https://photon.komoot.io/api/?q=" + encodeURIComponent(query) + "&limit=5&lang=de";
        
        currentRequest = $.get(apiUrl)
            .done(function(data) {
                var addresses = data.features.map(function(feature) {
                    return parseModalAddress(feature);
                });
                displayModalSuggestions(addresses, $dropdown);
            })
            .fail(function() {
                $dropdown.html('<div class="autocomplete-error">❌ Fehler beim Laden</div>');
            });
    }
    
    // Parse Photon address for modal
    function parseModalAddress(feature) {
        var props = feature.properties;
        var address = {
            street: props.street || "",
            housenumber: props.housenumber || "",
            postcode: props.postcode || "",
            city: props.city || props.name || "",
            state: props.state || "",
            country: props.country || "Deutschland",
            countryCode: props.countrycode ? props.countrycode.toUpperCase() : "DE"
        };
        
        address.fullStreet = address.street + (address.housenumber ? " " + address.housenumber : "");
        address.display = formatModalDisplay(address);
        address.hasHousenumber = !!address.housenumber;
        
        return address;
    }
    
    // Format address for modal display
    function formatModalDisplay(address) {
        var parts = [];
        
        if (address.fullStreet) {
            parts.push(address.fullStreet);
        }
        
        if (address.postcode && address.city) {
            parts.push(address.postcode + " " + address.city);
        } else if (address.city) {
            parts.push(address.city);
        }
        
        return parts.join(", ");
    }
    
    // Display modal address suggestions
    function displayModalSuggestions(addresses, $dropdown) {
        $dropdown.empty();
        
        if (addresses.length === 0) {
            $dropdown.html('<div class="autocomplete-empty">Keine Adressen gefunden</div>').show();
            return;
        }
        
        addresses.forEach(function(address) {
            var $item = $("<div>")
                .addClass("autocomplete-item")
                .html("📍 " + address.display)
                .data("address", address);
            
            if (!address.hasHousenumber && address.street) {
                $item.append(' <span class="missing-housenumber">⚠️ Hausnummer fehlt</span>');
            }
            
            $item.on("click", function() {
                fillModalFields(address);
                $dropdown.hide();
            });
            
            $dropdown.append($item);
        });
        
        $dropdown.show();
    }
    
    // Fill modal form fields
    function fillModalFields(address) {
        
        if (address.fullStreet) {
            $("#address_1").val(address.fullStreet);
        }
        
        if (address.postcode) {
            $("#address_postcode").val(address.postcode);
        }
        
        if (address.city) {
            $("#address_city").val(address.city);
        }
        
        if (address.countryCode) {
            // Update custom dropdown
            var $wrapper = $("#address_country").closest(".custom-select-wrapper");
            var $option = $wrapper.find('.custom-option[data-value="' + address.countryCode + '"]');
            
            if ($option.length > 0) {
                $("#address_country").val(address.countryCode);
                $wrapper.find(".selected-option").text($option.text());
                $option.addClass("selected").siblings().removeClass("selected");
            }
        }
        
        // DEBUG: ✅ Modal: Address fields filled;
    }
    
    // Load address data for editing
    function loadAddressForEditing(addressId) {
        
        $.ajax({
            url: vitalshop_address_manager.ajax_url,
            type: 'POST',
            data: {
                action: 'get_address_for_editing',
                address_id: addressId,
                nonce: vitalshop_address_manager.nonce_save
            },
            success: function(response) {
                
                if (response.success && response.data) {
                    fillEditForm(response.data);
                                    } else {
                        
                        showToast("Fehler beim Laden der Adresse", 'error');
                    }
                },
                error: function() {
                    
                    showToast("Fehler beim Laden der Adresse", 'error');
                }
        });
    }
    
    // Fill edit form with address data
    function fillEditForm(address) {
        
        // Fill text fields
        $("#address_label").val(address.label || '');
        $("#address_first_name").val(address.first_name || '');
        $("#address_last_name").val(address.last_name || '');
        $("#address_company").val(address.company || '');
        $("#address_1").val(address.address_1 || '');
        $("#address_2").val(address.address_2 || '');
        $("#address_city").val(address.city || '');
        $("#address_postcode").val(address.postcode || '');
        $("#address_state").val(address.state || '');
        $("#address_phone").val(address.phone || '');
        $("#address_email").val(address.email || '');
        
        // Fill country dropdown
        if (address.country) {
            var $wrapper = $("#address_country").closest(".custom-select-wrapper");
            var $option = $wrapper.find('.custom-option[data-value="' + address.country + '"]');
            
            if ($option.length > 0) {
                $("#address_country").val(address.country);
                $wrapper.find(".selected-option").text($option.text());
                $option.addClass("selected").siblings().removeClass("selected");
                
            }
        }
        
        // Fill default checkbox
        $("#address_is_default").prop("checked", address.is_default == 1);
        
        // DEBUG: ✅ Edit form filled successfully;
    }
    
    // Close modal
    $(".modal-close, .cancel-button, .modal-overlay").on("click", function() {
        $("#address-form-modal").hide();
    });
    
    // Prevent modal close when clicking inside modal content
    $(".modal-content").on("click", function(e) {
        e.stopPropagation();
    });
    
    // Handle form submission
    $("#address-form").on("submit", function(e) {
        e.preventDefault();
        
        var addressId = $("#address_id").val();
        var formData = {
            action: "save_user_address",
            nonce: vitalshop_address_manager.nonce_save,
            address_id: addressId, // Important for edit vs create
            label: $("#address_label").val(),
            first_name: $("#address_first_name").val(),
            last_name: $("#address_last_name").val(),
            company: $("#address_company").val(),
            address_1: $("#address_1").val(),
            address_2: $("#address_2").val(),
            postcode: $("#address_postcode").val(),
            city: $("#address_city").val(),
            country: $("#address_country").val(),
            phone: $("#address_phone").val(),
            email: $("#address_email").val(),
            is_default: $("#address_is_default").is(":checked") ? 1 : 0
        };
        
        
        $.ajax({
            url: vitalshop_address_manager.ajax_url,
            type: "POST",
            data: formData,
            beforeSend: function() {
                $(".button-primary").prop("disabled", true).text("Speichere...");
            },
            success: function(response) {
                if (response.success) {
                    showToast("Adresse erfolgreich gespeichert!");
                    
                    // Close modal with animation
                    $("#address-form-modal").fadeOut(300);
                    
                    // Store which address was updated for highlighting
                    if (addressId) {
                        localStorage.setItem('vitalshop_updated_address', addressId);
                    }
                    
                    // Reload after toast animation
                    setTimeout(function() {
                        location.reload();
                    }, 1000);
                } else {
                    showToast("Fehler: " + response.data, 'error');
                }
            },
            error: function() {
                showToast("Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.", 'error');
            },
            complete: function() {
                $(".button-primary").prop("disabled", false).text("Adresse speichern");
            }
        });
    });
    
    // Handle delete address
    $(".delete-address").on("click", function() {
        if (confirm("Möchten Sie diese Adresse wirklich löschen?")) {
            var addressId = $(this).closest(".address-card").data("address-id");
            
            $.ajax({
                url: vitalshop_address_manager.ajax_url,
                type: "POST",
                data: {
                    action: "delete_user_address",
                    nonce: vitalshop_address_manager.nonce_delete,
                    address_id: addressId
                },
                success: function(response) {
                    if (response.success) {
                        location.reload();
                                    } else {
                    showToast("Fehler beim Löschen: " + response.data, 'error');
                }
                }
            });
        }
    });
    
    // Handle set default
    $(".set-default").on("click", function() {
        var addressId = $(this).closest(".address-card").data("address-id");
        
        $.ajax({
            url: vitalshop_address_manager.ajax_url,
            type: "POST",
            data: {
                action: "set_default_address",
                nonce: vitalshop_address_manager.nonce_default,
                address_id: addressId
            },
            success: function(response) {
                if (response.success) {
                    location.reload();
                } else {
                    showToast("Fehler: " + response.data, 'error');
                }
            }
        });
    });
});